import { Component, Input, Output, EventEmitter, AfterContentInit, ViewChild, ElementRef, OnDestroy, SimpleChanges } from '@angular/core';
import { FirestoreService } from '../firestore-service.service';
import { Editor, NgxEditorModule, Toolbar } from 'ngx-editor';
import { Comment, FileUpload } from '../container';
import { FormControl, FormGroup, FormsModule } from '@angular/forms';
import { SharedServiceService } from '../shared-service.service';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { AttachedfilesComponent } from '../attachedfiles/attachedfiles.component';
import { UploadfileComponent } from '../uploadfile/uploadfile.component';

@Component({
    selector: 'app-addcomment',
    templateUrl: environment.site === 'wroolo' ? './addcomment.component.wroolo.html' : './addcomment.component.productly.html',
    styleUrls: ['./addcomment.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, AttachedfilesComponent, UploadfileComponent, NgxEditorModule],
})
export class AddcommentComponent implements AfterContentInit, OnDestroy {
  @Input()isAnonymous: boolean = true;
  @Input()userDisplayName: string = "";
  @Input()contentKey: string = "";
  @Input()userId: string = "";
  @Input()commentCount: number = 0;
  @Input()organizationKey: string = "";
  @Input()projectKey: string = "";
  @Input()projectName: string = "";
  @Input() channelKey: string = ""
  @Input() channelName: string = "";
  @Input() channelPath: string = "";
  @Input() commentKey: string = "";
  @Input() newComment: boolean = true;
  @Input() commentContent: string = "";
  @Input() contentType: string = "";
  @Input()doAddCover: boolean = true;
  @Input() userImageURL = ""
  @Input() canvasObjectKey: string = ""
  @Input() canvasObjectType: string = ""
  @Input() pathSegments: string[] = [];
  @Input() embeddingModel: string = ""
  @Input() parentCommentKey: string = "" // used to add comment to a parent comment, if empty, add comment to the content
  @Output() notify = new EventEmitter<{commentKey: string, isAddEditorPresent: boolean}>(); // used to show and hide editor if comment is edited
  @Output() onAddComment = new EventEmitter<Comment>();
  @Output() areCanvasEventsSuspended = new EventEmitter<boolean>();
  @Output() onEditorClosed = new EventEmitter();
  @Output() onCommentUpdated = new EventEmitter<{commentKey: string, content: string}>();
  @Output() onIsListening = new EventEmitter<boolean>();
 // @Input() isAddCommentEditorPresent: boolean = true

  //unsubscribeImages: Function;
  isUploaded = false
  selectedFiles?: FileList;
  currentFileUpload?: FileUpload;
  percentage = 0;
  //imageURLs: url[] = []
 // isCommentEditorPresented: boolean = true;
  editor: Editor = new Editor();
  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'strike'],
    ['code', 'blockquote'],
    ['ordered_list', 'bullet_list'],
    //[{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    //['link', 'image'],
    ['text_color', /*'background_color'*/],
    //['align_left', 'align_center', 'align_right', 'align_justify'],
  ];
  html = '';
  form = new FormGroup({
    content: new FormControl('')
  });
  showAttachements = true
  isCommandEnterHit = false
  shiftKeyPressed = false
 content: string = ""
  @ViewChild('editorId', {static: false}) ngxEditor: ElementRef;

  constructor(private firestore: FirestoreService, public service: SharedServiceService, private dialog: MatDialog) {
  }

  ngOnInit() {
   if (this.commentKey == "") {
    this.createCommentKey()
    } 
  }

  ngAfterContentInit() {
    this.content = this.commentContent
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['canvasObjectKey']) {
     this.content = ""
     this.editor.commands.insertHTML("").exec()
    }
  }

  ngOnDestroy() {
   this.editor.destroy();
  }

  async createCommentKey() {
    await this.firestore.getNewCommentId(this.organizationKey, this.contentKey).then((commentKey) => {
      this.commentKey = commentKey
    })
  }

  commandEnterHit() {
    this.addComment()
    this.isCommandEnterHit = true
  } 

  onKeyDown(event: KeyboardEvent): void { // this is used to add comment when command+enter is pressed
    this.areCanvasEventsSuspended.emit(true)
    if (event.key === 'Enter') {
      if (event.metaKey || event.ctrlKey) { // Command+Enter (or Control+Enter) for adding comment
        event.preventDefault();
        this.addComment()
      }
    }
    if (event.key === 'Shift') {
      this.shiftKeyPressed = true
    }
  }

  onKeyUp(event: KeyboardEvent): void { // this is used to add comment when command+enter is pressed
    this.areCanvasEventsSuspended.emit(false)
    if (event.key === 'Shift') {
      this.shiftKeyPressed = false
    }
  }

  async addComment() {
    this.onIsListening.emit(false)
    const comment: Comment = {
      "content": this.content,
      "dateOfCreation": new Date(),
      "dateOfUpdate": new Date(),
      "formattedDate": this.firestore.formatCommentDate(new Date()),
      "isDeleted": false,
      "projectKey": this.projectKey,
      "userName": this.userDisplayName,
      "userId": this.userId,
      "userImageURL": this.userImageURL,
      "key": this.commentKey,
      "imageURLS": [],
      "canvasObjectKey": this.canvasObjectKey,
      "canvasObjectType": this.canvasObjectType,
      "parentCommentKey": this.parentCommentKey
    }

    await this.firestore.addComment2(this.organizationKey, this.contentKey, comment, this.commentKey)
    if (this.commentKey == "" || this.commentKey == undefined) { // if comment key was empty, it means that the comment was added successfully
     // comment.key = commentKey
      this.firestore.showSnackBar("Your comment was added, thanks for involvement.")
      this.onAddComment.emit(comment)
    } else { // if comment key was not empty, it means that the comment was updated successfully
      this.onCommentUpdated.emit({commentKey: this.commentKey, content: this.content})
      this.onAddComment.emit(comment)
      this.firestore.showSnackBar("Your comment was updated.")
    }
    this.content = ""
    setTimeout(() => { // NARAZIE TEN TIMEOUT MUSZE ZOSTAWIĆ, BO NIE DO KONCA JEST WSZYSTKO ASYNCHRONICZNE I NIE CZEKA NA SKONCZENIE WSZYSTKICH UPDATEÓW!!!!
      this.onIsListening.emit(true)
    }, 3000)
    this.createCommentKey()
  }

  copyTextToClipboard(text: string) {
    text = "https://app.prodely.com/channel/"+text
    this.firestore.copyTextToClipboard(text);
  }

  updateCoverImage(url: string) {
  }

  getImageDescription(description: string) {
  }

  isFileUploaded(arg: {"isFileUploaded": boolean, "url": string}) { // fired when file is uploaded to a new comment
    this.isUploaded = arg.isFileUploaded
    if (arg.isFileUploaded == true) {
      //this.unsubscribeImages()
     // this.startListeningToImages(this.channelKey, this.commentKey)
      //this.getImages()
    }
  }

  async showCommentEditor() {
    //this.isAddCommentEditorPresent = true
    this.content = ""
    this.commentKey = await this.firestore.getNewCommentId(this.organizationKey, this.contentKey)
    //this.notify.emit({"commentKey": "", "isAddEditorPresent": this.isAddCommentEditorPresent})
  }

  closeEditor() {
    this.onEditorClosed.emit()
    this.service.editedCommentKey = ""
  }

}

